import { useState } from "react";
import styles from "./authTextInput.module.css";
import eyeImage from "../../../assets/images/svgs/eye.png";
import userImage from "../../../assets/images/svgs/user.png";
import lockImage from "../../../assets/images/svgs/lock.png";
import { getRegexErrorMessage } from "../../../utils/regexCheck";
import TextWrapper from "../../textWrapper/TextWrapper";

const AuthTextInput = ({
  placeholder,
  height,
  width,
  borderRadius,
  bgColor,
  value,
  setValue,
  isPassword,
  regex,
  setEligibility,
  direction = "rtl",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (regex) {
      const errorMessageToShow = getRegexErrorMessage(newValue, regex);
      setError(errorMessageToShow);

      if (!errorMessageToShow) {
        setEligibility(true);
      } else {
        setEligibility(false);
      }
    }
  };

  return (
    <>
      {isPassword ? (
        <div
          className={`${styles.textInputWrapper} ${styles[bgColor]} ${
            direction === "ltr" ? styles.ltrWrapper : ""
          }`}
          style={{ height, width, borderRadius }}
        >
          <img src={lockImage} alt="lock" className={styles.svgImage} />
          <input
            type={showPassword ? "text" : "password"}
            className={`${styles.textInput} ${styles[bgColor]} ${
              direction === "ltr" ? styles.ltrInput : ""
            }`}
            value={value}
            onChange={(e) => handleChange(e)}
            placeholder={placeholder}
          />
          <div
            className={styles.eyeContainer}
            onClick={() => setShowPassword(!showPassword)}
          >
            <img src={eyeImage} alt="Password Eye" />
          </div>
        </div>
      ) : (
        <div
          className={`${styles.textInputWrapper} ${styles[bgColor]} ${
            direction === "ltr" ? styles.ltrWrapper : ""
          }`}
          style={{ height, width, borderRadius }}
        >
          <img src={userImage} alt="user" className={styles.svgImage} />
          <input
            type="text"
            className={`${styles.textInput} ${styles[bgColor]} ${
              direction === "ltr" ? styles.ltrInput : ""
            }`}
            value={value}
            onChange={(e) => handleChange(e)}
            placeholder={placeholder}
          />
        </div>
      )}
      {error && (
        <div className={styles.errorWrapper}>
          <TextWrapper textStyle="textSmall">{error}</TextWrapper>
        </div>
      )}
    </>
  );
};

export default AuthTextInput;
